"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNumberColumnFilterSortConfig = void 0;
const react_1 = require("react");
const ui_components_1 = require("@groupby/ui-components");
const useNumberColumnFilterSortConfig = () => {
    const getFilterConfig = (0, react_1.useCallback)(() => ({
        filterable: true,
        sortable: true,
        filterOperators: (0, ui_components_1.createNumberFilterOperators)({ inputProps: {} }),
    }), []);
    return getFilterConfig;
};
exports.useNumberColumnFilterSortConfig = useNumberColumnFilterSortConfig;
